// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ly_Yk{display:flex;flex-direction:column;gap:8px}.a2X0e{margin-top:16px;width:390px;margin-left:30px}.QNXeJ{display:flex;flex-direction:column}.xQx7u{display:flex;flex-direction:column;gap:24px}.qiPtP{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"billingSelectorsWrapper": `Ly_Yk`,
	"manualServicesSelector": `a2X0e`,
	"serviceOption": `QNXeJ`,
	"globalBillModalContent": `xQx7u`,
	"serviceOptionContent": `qiPtP`
};
export default ___CSS_LOADER_EXPORT___;
